import { ExportDropdownItem } from "components/common/buttons/ExportDropdownButton";
import { Layout, LoadingWrapper, PageTitle } from "components/common/layouts";
import { TablePulseSurveyFeedback } from "components/form-feedback";
import { ERROR_GENERATE_REPORT } from "constants/messages.constant";
import { useError, useHttpMutationService, useHttpQueryService } from "hooks";
import { isEmpty } from "lodash";
import { useState } from "react";
import { FeedbackService, FormService } from "services";
import { toastError } from "utils/toast";

const PulseSurveyList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formId, setFormId] = useState(-1);

  const createDropdownItems: ExportDropdownItem[] = [
    {
      label: "Export as Microsoft Excel (.xlsx)",
      isExporting: false,
      onAction: (index: number) => {
        createDropdownItems[index].isExporting = true;
        downloadReport(formId, index);
      },
    },
  ];

  const {
    result: forms,
    error,
    isLoading,
  } = useHttpQueryService({
    request: () => FormService.getPulseSurveyFormFeedback(),
  });

  const { mutate: getPulseSurveyReport, error: fetchReportError } =
    useHttpMutationService({
      request: (formId?: number) =>
        FeedbackService.getPulseSurveyReport(formId!),
    });

  useError(error);
  useError(fetchReportError);

  const downloadReport = async (formId: number, dropdownId: number) => {
    const report = await getPulseSurveyReport(formId);

    if (report) {
      const url = window.URL.createObjectURL(report.blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = report.filename;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      toastError(ERROR_GENERATE_REPORT);
    }

    resetState(dropdownId);
  };

  const resetState = (dropdownId: number) => {
    createDropdownItems[dropdownId].isExporting = false;
    setIsOpen(false);
    setFormId(-1);
  };

  const handleOpenChange = (nextFormId: number) => {
    setFormId(nextFormId);
    setIsOpen(!isOpen);
  };

  return (
    <Layout>
      <LoadingWrapper isLoading={isLoading}>
        <PageTitle className="mb-6">Pulse Survey</PageTitle>
        {isEmpty(forms) ? (
          <p>There is no pulse survey available</p>
        ) : (
          <TablePulseSurveyFeedback
            items={createDropdownItems}
            isOpen={isOpen}
            onOpenChange={handleOpenChange}
            formId={formId}
            forms={forms!}
          />
        )}
      </LoadingWrapper>
    </Layout>
  );
};

export default PulseSurveyList;
